<form role="form" [formGroup]="group">
  <h4 mat-dialog-title translate="JobLine.JobLine"></h4>
  <mat-dialog-content>
    <div class="row">
      <abi-form-field [horizontal]="false" cols="col-md-12">
        <div ngbRadioGroup class="mt-1 btn-group btn-group-toggle" name="type" formControlName="typeId">
          <label *ngFor="let line of lineTypes" ngbButtonLabel class="btn btn-outline-primary">
            <input ngbButton type="radio" [value]="line.code">{{ line.description }}
          </label>
        </div>
      </abi-form-field>
      <abi-form-field [horizontal]="false" cols="col-12">
        <input formControlName="itemId" abiTypeahead [abiStock]="group.get('typeId').value" [parentId]="parentId" [warehouseId]="warehouseId"
          [mode]="getMode(group.get('typeId').value)" (selectItem)="showStock($event.item)" inputDisplay="code" />
      </abi-form-field>
      <abi-form-field [horizontal]="false" cols="col-12">
        <input abiProductHint="JobLine.Description" formControlName="line1" />
      </abi-form-field>

      <div class="col-6">
        <div class="row">

            <abi-form-field [horizontal]="false" label="JobLine.OnHand" cols="col">
                <input type="text" [ngModelOptions]="{standalone: true}" [ngModel]="available" class="text-right" disabled />
              </abi-form-field>
              <abi-form-field [horizontal]="false" label="JobLine.Quantity" cols="pl-0 col">
                <input type="text" mask="separator.0" abiProductHint="JobLine.Quantity" formControlName="quantityOrdered" class="text-right" />
              </abi-form-field>
              <abi-form-field *ngIf="canChangePayment" [horizontal]="false" label="JobLine.Payment" cols="pl-0 col">
                <select class="custom-select" formControlName="mode">
                    <option *ngFor="let paymentType of paymentTypes" [ngValue]="paymentType">{{ paymentType }}</option>
                </select>
              </abi-form-field>
        </div>
      </div>
      <div class="col-6">
        <div class="row">

            <abi-form-field *hasClaim="'JobLineShow' +group.getRawValue()['typeId']+ 'Price'" [horizontal]="false" label="JobLine.Price" cols=" pl-0 col">
                <input type="text" mask="separator.2" [allowNegativeNumbers]="allowNegativeNumbers" abiProductHint="JobLine.Price" formControlName="price" class="text-right" />
              </abi-form-field>
              <abi-form-field *hasClaim="'JobLineShow' +group.getRawValue()['typeId']+ 'Price'" [horizontal]="false" label="JobLine.Amount" cols="pl-0 col">
                <input type="text" mask="separator.2" [allowNegativeNumbers]="allowNegativeNumbers" abiProductHint="JobLine.Amount" formControlName="amount" class="text-right" />
              </abi-form-field>
        </div>
      </div>


    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" mat-button (click)="cancel()" translate="System.Cancel"></button>
    <button type="button" mat-button [disabled]="group.invalid" [mat-dialog-close]="true" translate="System.Ok"></button>
    <button type="button" mat-button color="warn" *ngIf="onDelete && group.get('itemId').enabled" (click)="delete()" translate="System.Delete"></button>
  </mat-dialog-actions>
</form>
